import { getFromStorage } from "../../utils/storageUtils";
import instance from "../../utils/BaseService";

export const logoutApi = () =>
  instance.put("/Authentication/logout", null, {
    headers: {
       access_token: localStorage.getItem("token"),
    }
  });

